module.exports = __webpack_public_path__ + "static/media/truck-monster.f9f4f795.svg";